import { DashboardCustomListRestEndpointService } from '@api'
import type { PaginationState } from '@tanstack/react-table'
import { useUnit } from 'effector-react'
import { useQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'
import { handleError } from '@/utils/error'

export const useCustomLists = (
  paginationState: PaginationState,
  searchQuery: string,
) => {
  const creatorId = useUnit($creatorId)

  const query = useQuery({
    queryKey: [
      'creator',
      creatorId,
      'custom-lists',
      paginationState,
      searchQuery,
    ],
    queryFn: () =>
      DashboardCustomListRestEndpointService.dashboardGetCustomLists({
        creatorId: creatorId!,
        page: paginationState.pageIndex,
        size: paginationState.pageSize,
        name: searchQuery,
      }),
    enabled: !!creatorId,
    onError: (error) =>
      handleError(error, 'Failed to get custom lists', query.refetch),
  })

  return {
    customLists: query.data,
    isLoading: query.isFetching,
    isError: query.isError,
  }
}
